module.exports = __webpack_public_path__ + "img/LOTTE_FINANCE.fca30299.svg";